import React from "react";
import Link from "next/link";
import MuiBreadcrumbs from "@material-ui/core/Breadcrumbs";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { useRouter } from "next/router";
interface StyleProps {
  borderBottom: boolean;
}
const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2, 0),
      borderBottom: (props: StyleProps) =>
        props.borderBottom ? `1px solid ${theme.palette.divider}` : "none",
    },
    breadcrumb: {
      "& a": {
        color: theme.palette.grey[600],
        fontSize: 13,
      },
      "& p": {
        color: theme.palette.grey[800],
        fontSize: 13,
      },
    },
  })
);
const Breadcrumbs: React.FC<BreadcrumbProps> = ({ data, borderBottom }) => {
  const classes = useStyle({ borderBottom });
  const router = useRouter();
  const { country } = router?.query;

  const breadcrumbSchema = React.useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: data?.map((item, index, items) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        ...(index + 1 !== items.length && {
          item: process.env.NEXT_PUBLIC_APP_URL + item.slug,
        }),
      })),
    };
  }, [data]);

  const createLink = React.useCallback(
    (slug: string = "", isCategory: boolean) => {
      const basePath = country ? `/${country}` : "";
      const path = isCategory ? `/courses${slug}` : slug;

      return `${basePath}${path}`;
    },
    [country]
  );

  return (
    <Box className={classes.root}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema),
        }}
      />

      <Container>
        <MuiBreadcrumbs
          className={classes.breadcrumb}
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          {data?.map((item, index, row) => {
            if (index === row.length - 1) {
              return (
                <Typography key={`breadcrumb-${index}`} aria-current="page">
                  {item.name}
                </Typography>
              );
            } else {
              return (
                <Link
                  href={createLink(item?.slug, index === 2)}
                  key={`breadcrumb-${index}`}
                >
                  {item.name}
                </Link>
              );
            }
          })}
        </MuiBreadcrumbs>
      </Container>
    </Box>
  );
};

export default Breadcrumbs;
